







































































































import {
    defineComponent,
    onMounted,
    computed,
    ref,
} from "@nuxtjs/composition-api";
import { usePartsBySku } from "~/modules/part-finder/composables/usePartsBySku";
import { SfHeading } from "@storefront-ui/vue";
import SkeletonLoader from "components/theme/SkeletonLoader.vue";

import type { FittingListEntry } from "~/modules/part-finder/types";

export default defineComponent({
    name: "FittingParts",
    props: {
        sku: {
            type: String,
            required: true,
        },
    },
    components: {
        SfHeading,
        SkeletonLoader,
    },
    methods: {
        highlight(blurb, query) {
            if (!query) {
                return blurb;
            }
            const test = new RegExp(`(${query})`, "gi");

            if (!test.test(blurb)) {
                return blurb;
            }
            return blurb.replace(test, '<span class="highlight">$1</span>');
        },
    },
    setup(props) {
        const { load, loading, error } = usePartsBySku(props.sku);

        const query = ref<string>("");
        const fittingList = ref<FittingListEntry[]>([]);
        const sortedList = computed(() => {
            if (fittingList.value.length) {
                return fittingList.value
                    .filter((item) => {
                        return (
                            item.finder.name
                                .toLowerCase()
                                .includes(query.value.toLowerCase()) ||
                            item.brand.name
                                .toLowerCase()
                                .includes(query.value.toLowerCase()) ||
                            item.model.name
                                .toLowerCase()
                                .includes(query.value.toLowerCase()) ||
                            (item.notes &&
                                item.notes
                                    .toLowerCase()
                                    .includes(query.value.toLowerCase()))
                        );
                    })
                    .sort((a, b) => {
                        return (
                            a.finder.name.localeCompare(b.finder.name) ||
                            a.brand.name.localeCompare(b.brand.name) ||
                            a.model.name.localeCompare(b.model.name)
                        );
                    });
            }
            return [];
        });

        onMounted(async () => {
            fittingList.value = await load();
        });

        return {
            fittingList: sortedList,
            loading,
            error,
            query,
        };
    },
});
